import store from '@/store/index'
import initialTheme from '@/utils/presets/allPresets/Yellow/yellow.ts'
import { setCashierThemeLightOrDark } from '@/utils/gamblingHelpers'
import sharedCss from '@/utils/presets/allPresets/SharedConfigs/css'
import {
  localStorageConfigsName,
  dynamicCashierTypes
} from '@/utils/types'
const {
  STANDARD_FLOW,
  SINGLE_PAGE_FLOW,
  CARDS_FLOW
} = dynamicCashierTypes

const stateConfigs = () => store.state.cashierContext.config
const cashierContext = () => store.state.cashierContext
const gamblingContext = () => store.state.gamblingContext

const setQuickDeposit = (val: boolean): void => { store.commit('setQuickDeposit', val) }
let quickDepositValue = false

const checkForSavedConfigs = (): any | object => {
  const __CASHIER_DEMO_CONFIGS__: string | null = localStorage.getItem(localStorageConfigsName)
  const configs = __CASHIER_DEMO_CONFIGS__ && JSON.parse(__CASHIER_DEMO_CONFIGS__)
  return configs && configs.demoThemesOptions && configs.demoThemesOptions.dynamicCashierType && {
    dynamicCashierType: configs.demoThemesOptions.dynamicCashierType
  }
}

const lookupConfig = {
  country: 'SE',
  didClientId: 'bambora_prod',
  identifyFields: 'email, zip',
  identifyProvider: 'bankId',
  checkUserDevice: false,
  locale: 'en_GB'
}

const resetSettings = {
  amount: 200,
  tabs: true,
  showHeader: false,
  showFooter: false,
  showTransactionsOnly: false
}

let customConfigs = {}
const setConfigs = (obj: object) => {
  if (gamblingContext().pageLayout === 'layout4') {
    // We want a white LIGHT BG for the layout4 type
    allCashierTypes().whiteBackground()
  }
  setQuickDeposit(quickDepositValue)
  quickDepositValue = false
  const configs = {
    ...resetSettings,
    ...obj,
    ...customConfigs,
    ...cashierContext().checkoutClient && { lookupConfig }
  }

  store.dispatch('setConfigs', configs)
  store.commit('setLatestConfig', configs)
}
let customCssGlobal = ''
const setCustomCss = (css: string) => {
  const mergedCss = `
   ${sharedCss}
   ${css}
  `
  customCssGlobal = mergedCss
  store.commit('setCustomCss', mergedCss)
  store.commit('setLatestCss', mergedCss)
}
const setTheme = (theme: object) => { store.dispatch('setTheme', theme) }

const allCashierTypes: any = (): object => ({

  updateLatest: () => {
    const { config, css } = gamblingContext().latestConfigs
    setCustomCss(css)
    setConfigs(config)
  },

  mergeMultipleConfigs: (configsToMerge: string[]) => {
    let configs = {}
    let mergedCss = ''
    configsToMerge && configsToMerge.forEach((val: any) => {
      configs = {
        ...configs,
        ...allCashierTypes()[val]()
      }
      mergedCss += customCssGlobal
    })
    setCustomCss(mergedCss)
    setConfigs(configs)
  },

  bankingPageFlow: (willBeMerged: boolean = false) => {
    setCustomCss('')
    const configs = {
      mode: 'ecommerce',
      tabs: false,
      showHeader: true,
      listType: 'grid',
      amount: null
    }
    !willBeMerged && setConfigs(configs)
    return configs
  },

  standardFlow: (willBeMerged: boolean = false) => {
    setCustomCss('')
    const configs = {}
    !willBeMerged && setConfigs(configs)
    return configs
  },

  singlePageFlow: (willBeMerged: boolean = false) => {
    setCustomCss('')
    const configs = {
      singlePageFlow: true
    }
    !willBeMerged && setConfigs(configs)
    return configs
  },

  cardsFlow: (willBeMerged: boolean = false) => {
    setCustomCss('')
    const configs = {
      listType: 'grid'
    }
    !willBeMerged && setConfigs(configs)
    return configs
  },

  amountFirst: (willBeMerged: boolean = false) => {
    setCustomCss('')
    const configs = {
      amount: null,
      amountFirst: true,
      listType: 'grid'
    }
    !willBeMerged && setConfigs(configs)
    return configs
  },

  transactions: (willBeMerged: boolean = false) => {
    setCustomCss('')
    const configs = {
      showTransactionsOnly: true
    }
    !willBeMerged && setConfigs(configs)
    return configs
  },

  quickDeposit: (willBeMerged: boolean = false) => {
    quickDepositValue = true
    const state = stateConfigs()
    const newCss = '.header .header-left{visibility:hidden}'
    setCashierThemeLightOrDark(setTheme, true, '#ffffff')
    setCustomCss(newCss)
    const configs = {
      ...state,
      method: 'deposit',
      amount: 500,
      amountFirst: false,
      providerType: cashierContext().autoProcessProvider,
      autoProcess: true
    }
    !willBeMerged && setConfigs(configs)
    return configs
  },

  dynamicCashierType: (willBeMerged: boolean = false) => {
    let configs = {}
    customConfigs = {
      history: true,
      tabs: true,
      showHeader: true
    }
    const savedConfigs = checkForSavedConfigs()
    const cashierType: string = cashierContext().cashierType ||
    (savedConfigs && savedConfigs.dynamicCashierType) || ''

    switch (cashierType) {
      case '':
      case STANDARD_FLOW:
        configs = allCashierTypes().standardFlow(willBeMerged)
        break
      case SINGLE_PAGE_FLOW:
        configs = allCashierTypes().singlePageFlow(willBeMerged)
        break
      case CARDS_FLOW:
        configs = allCashierTypes().cardsFlow(willBeMerged)
        break
    }
    const css = `
      #cashier {
        margin-top: -1px!important;
      }
    `
    setCustomCss(css)
    return configs
  },

  setCustomConfig: (customConfigPar: object) => {
    customConfigs = customConfigPar
  },

  whiteBackground: () => {
    const css = `
      #cashier {
        background: transparent!important;
      }
      .amount.route-container {
        background: transparent!important;
      }
      .header {
        padding: 10px;
        border-radius: 12px;
        border: 1px solid var(--border-color);
      }
      .header .no-select.notranslate {
        background: #333333!important;
        color: #ffffff!important;
      }
      .header h4,
      .header .masked-account {
        color: #555555!important;
      }
      .receipt h4,
      .receipt span,
      .receipt .success-message-label {
        color: #333333!important;
      }
      .set-amount .predefinedvalues button {
        box-shadow: 1px 1px 1px 0px grey;
      }
    `
    setCustomCss(css)
    return {}
  }
})

export default {
  ...allCashierTypes()
}
